import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { StickyToComponent } from './stickyToComponent'
import { LifeCycle } from '@wix/thunderbolt-symbols'
import { StickyToComponentSymbol, ShouldObserveHeaderHandlerSymbol } from './symbols'
import { HeaderObserverHandler } from './headerObserverHandler'
import { ShouldObserveHeaderHandler } from './shouldObserveHeaderHandler'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageDidMountHandler, LifeCycle.PageWillUnmountHandler, LifeCycle.PageDidUnmountHandler).to(
		HeaderObserverHandler
	)
	bind(ShouldObserveHeaderHandlerSymbol).to(ShouldObserveHeaderHandler)
	bind(StickyToComponentSymbol).to(StickyToComponent)
}
